const appHeight = () => {
  const doc = document.documentElement
  doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
document.addEventListener('DOMContentLoaded', appHeight)
